export default __webpack_public_path__ + "media/images/cta_blocks/set_wedding_date-a44e2b557210dd203d4df68834f656e7.jpg";